<template>
  <div class="item">
    <div v-if="value" class="img"><img :src="value" /></div>
    <div>
      <template v-if="item.disabled">
        <span class="btn1" v-if="!value">未签名</span>
      </template>
      <a v-else class="btn" @click.stop="handleOpen">去签名</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      required: true
    }
  },
  methods: {
    handleOpen() {
      this.$emit('on-open')
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  font-size: 14px;
  .label {
    color: #323233;
    vertical-align: middle;
    word-wrap: break-word;
    font-weight: 600;
    width: 6.2em;
    margin-right: 12px;
  }
  .img {
    position: relative;
    img {
      max-width: 150px;
      max-height: 30px;
    }
  }
}
.btn {
  display: inline-block;
  color: blue;
  cursor: pointer;
  font-size: 16px;
}
.btn1 {
  font-size: 16px;
  color: #666;
}
.required {
  &::before{
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }
}
</style>

